/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AnimalType } from '../models/animal-type';
import { findAll15 } from '../fn/animal-types/find-all-15';
import { FindAll15$Params } from '../fn/animal-types/find-all-15';

@Injectable({ providedIn: 'root' })
export class AnimalTypesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findAll15()` */
  static readonly FindAll15Path = '/api/values/animal-types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll15()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll15$Response(params?: FindAll15$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AnimalType>>> {
    return findAll15(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAll15$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll15(params?: FindAll15$Params, context?: HttpContext): Observable<Array<AnimalType>> {
    return this.findAll15$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AnimalType>>): Array<AnimalType> => r.body)
    );
  }

}
